import { API } from '@aws-amplify/api'
import {
  addUnassignedData,
  addAssignedData,
  addQCCasesData,
  addLabManagerCompleteData,
  updateAssignedDataFetchInProgress,
  updateLMCompleteDataFetchInProgress,
  updateQCDataFetchInProgress,
  updateUnAssignedDataFetchInProgress,
  addLabTransferList,
  updateUnassignResponse,
  updateTransferResponse,
  updateCorrectionResponse,
  updateAmendResponse,
  getLabTransferListResponse,
} from '../actions'
import { WOMA_API_GATEWAY_NAME } from '../../constants/aws'

interface DataRequest {
  id?: string | null | string[]
  pageIndex?: number | 1
  pageSize?: number | 10
  caseView: string
  filterField: string | null
  filterValue: any | Record<string, unknown> | null //chaanged to Record for linting
  startDate: string | null
  endDate: string | null
  sortOrder: string | null
  sortField: string | null
}

interface TransferRequest {
  id?: string | null | string[]
  currentUserId?: string | null | string[]
  newUserId: string | null | string[]
  casedId: string | null | string[]
}

export const getUnassignedData =
  ({
    id,
    pageIndex,
    pageSize,
    filterField,
    filterValue,
    caseView,
    startDate,
    endDate,
    sortOrder,
    sortField,
  }: DataRequest) =>
  async (dispatch) => {
    if (!id || id instanceof Array) return

    const apiName = '/case-management/labmanager/all-cases'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
          filterField: filterField,
          filterValue: filterValue,
          caseView: caseView,
          startDate: startDate,
          endDate: endDate,
          sortOrder: sortOrder,
          sortField: sortField,
        },
      }
      dispatch(updateUnAssignedDataFetchInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}`, options)

      if (result?.data) {
        dispatch(addUnassignedData({ payload: result, userId: id }))
      }
    } catch (err) {
      console.log('getUnassignedData Error', err)
    } finally {
      dispatch(updateUnAssignedDataFetchInProgress(false))
    }
  }
export const getAssignedData =
  ({
    id,
    pageIndex,
    pageSize,
    filterField,
    filterValue,
    caseView,
    startDate,
    endDate,
    sortOrder,
    sortField,
  }: DataRequest) =>
  async (dispatch) => {
    if (!id || id instanceof Array) return

    const apiName = '/case-management/labmanager/all-cases'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
          filterField: filterField,
          filterValue: filterValue,
          caseView: caseView,
          startDate: startDate,
          endDate: endDate,
          sortOrder: sortOrder,
          sortField: sortField,
        },
      }

      dispatch(updateAssignedDataFetchInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}`, options)

      if (result?.data) {
        dispatch(addAssignedData({ payload: result, userId: id }))
      }
    } catch (err) {
      console.log('getAssignedData Error', err)
    } finally {
      dispatch(updateAssignedDataFetchInProgress(false))
    }
  }

export const getQCCasesData =
  ({ id }: DataRequest) =>
  async (dispatch) => {
    if (!id || id instanceof Array) return

    const apiName = '/case-management/labmanager/all-cases'
    try {
      const options = {
        headers: {},
        response: false,
      }
      dispatch(updateQCDataFetchInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}`, options)

      if (result?.data) {
        dispatch(addQCCasesData({ payload: result, userId: id }))
      }
    } catch (err) {
      console.log('getQCCasesData Error', err)
    } finally {
      dispatch(updateQCDataFetchInProgress(false))
    }
  }

export const getLabManagerCompleteData =
  ({
    id,
    pageIndex,
    pageSize,
    filterField,
    filterValue,
    caseView,
    startDate,
    endDate,
    sortOrder,
    sortField,
  }: DataRequest) =>
  async (dispatch) => {
    if (!id || id instanceof Array) return
    const apiName = '/case-management/labmanager/all-cases'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          page_number: pageIndex ? pageIndex : 1,
          page_size: pageSize ? pageSize : 10,
          filterField: filterField,
          filterValue: filterValue,
          caseView: caseView,
          startDate: startDate,
          endDate: endDate,
          sortOrder: sortOrder,
          sortField: sortField,
        },
      }
      dispatch(updateLMCompleteDataFetchInProgress(true))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}`, options)

      if (result?.data) {
        dispatch(addLabManagerCompleteData({ payload: result, userId: id }))
      }
    } catch (err) {
      console.log('getLabManagerCompleteData Error', err)
    } finally {
      dispatch(updateLMCompleteDataFetchInProgress(false))
    }
  }

export const transferAssign =
  ({ currentUserId, id, newUserId, casedId }: TransferRequest) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/case-management/labmanager/transfer-case'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          caseid: casedId,
          currentid: currentUserId,
          newid: newUserId,
        },
      }
      const result = await API.put(WOMA_API_GATEWAY_NAME, `${apiName}/${id}?`, options)
      action = 'TRANSFER_CASE_SUCCESS'
    } catch (err) {
      action = 'TRANSFER_CASE_ERROR'
      console.log('transfer case error', err)
    } finally {
      dispatch(updateTransferResponse({ action: action }))
    }
  }

export const getLabTransferList =
  ({ caseUserId, id, casedId }) =>
  async (dispatch) => {
    const apiName = '/case-management/labmanager/transfer-list'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          caseid: casedId,
          caseuserid: caseUserId,
        },
      }
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${id}?`, options)
      if (result?.data) {
        if (result?.data.length === 0) {
          dispatch(getLabTransferListResponse({ action: 'EMPTY_TRANSFER_LIST' }))
        } else {
          dispatch(addLabTransferList({ payload: result }))
          dispatch(getLabTransferListResponse({ action: 'ADD_TRANSFER_LIST' }))
        }
      }
    } catch (err) {
      console.log('Cases Error', err)
    }
  }

export const unassignCase =
  ({ userid, currentid, caseid }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/case-management/labmanager/reset-case-assignment'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          currentid: currentid,
          caseid: caseid,
        },
      }
      const result = await API.put(WOMA_API_GATEWAY_NAME, `${apiName}/${userid}?`, options)
      action = 'UNASSIGN_CASE_SUCCESS'
    } catch (err) {
      console.log('Cases Error', err)
      action = 'UNASSIGN_CASE_ERROR'
    } finally {
      dispatch(updateUnassignResponse({ action: action }))
    }
  }

export const correction =
  ({ userid, newid, caseid }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/case-management/labmanager/correct'
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          newid: newid,
          caseid: caseid,
        },
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}/${userid}?`, options)
      action = 'CORRECTION_CASE_SUCCESS'
    } catch (err) {
      console.log('Cases Error', err)
      action = 'CORRECTION_CASE_ERROR'
    } finally {
      dispatch(updateCorrectionResponse({ action: action }))
    }
  }

export const amend =
  ({ userid, newid, caseid }) =>
  async (dispatch) => {
    let action = ''
    const apiName = '/case-management/labmanager/amend'
    dispatch(updateAmendResponse({ action: 'AMEND_CASE_INPROGRESS' }))
    try {
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          newid: newid,
          caseid: caseid,
        },
      }
      const result = await API.post(WOMA_API_GATEWAY_NAME, `${apiName}/${userid}?`, options)
      action = 'AMEND_CASE_SUCCESS'
    } catch (err) {
      console.log('Cases Error', err)
      action = 'AMEND_CASE_ERROR'
    } finally {
      dispatch(updateAmendResponse({ action: action }))
    }
  }
